<template lang="pug">
  div.event-compare(:class="{active: showEvts}" v-if="!compareIds.length" :style="{bottom: `${bottom}px`}")
    div.utils(@click.prevent="showEvts = !showEvts")
      div.vs VS
      p 危机对比
    transition(name="move")
      div.evts(v-if="showEvts")
        div.evts_title 危机标题
        div.evt(v-for="evt in evts" :key="evt.id")
          span {{evt.eventName}}
          button(@click.prevent="compare(evt)") 对比
</template>

<script>
export default {
  name: 'EventCompare',
  data () {
    return {
      showEvts: false
    }
  },
  computed: {
    compareIds () {
      return this.$store.getters.compareIds
    }
  },
  props: ['evts', 'event', 'bottom'],
  methods: {
    compare (evt) {
      let data = [
        {
          id: this.event.id,
          imgUrl: this.event.imgUrl,
          eventName: this.event.eventName
        },
        evt
      ]
      this.$store.dispatch('updateCompareIds', data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .event-compare{
    width: 66px;
    height: 66px;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 0 10px  rgba(0,0,0,0.1);
    position: fixed;
    right: 20px;
    text-align: center;
    .utils{
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    &.active{
      background-color: #f87653;
      p{
        color: #fff;
      }
      .vs{
        color: #fff;
        border: 2px solid #fff;
      }
    }
    .vs{
      margin: 10px auto;
      width: 22px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      font-size: 13px;
      border: 2px solid #f87653;
      color: #f87653;
    }
    p{
      margin-top: 5px;
      color: #f87e5c;
      font-size: 12px;
    }
    .evts{
      width: 380px;
      height: 250px;
      position: absolute;
      left: -380px;
      top: -250px;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 0 10px  rgba(0,0,0,0.1);
      padding: 10px;
      .evts_title{
        text-align: left;
      }
      .evt{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;
        span{
          color: #666;
        }
        button{
          min-width: 52px;
          height: 26px;
          line-height: 26px;
          border-radius: 4px;
          border: solid 1px #3989cb;
          color: #3989cb;
          background-color: #fff;
          &:hover{
            background-color: #3989cb;
            color: #fff;
          }
        }
      }
    }
    .move-enter-active, .move-leave-active {
      transition: transform .5s;
      transform:  scale(1);
      transform-origin: 100% 100%;
      /*position: absolute;*/
      /*left: 0;*/
      /*top: 0;*/
    }
    .move-enter, .move-leave-to /* .fade-leave-active below version 2.1.8 */ {
      transform-origin: 100% 100%;
      transform: scale(0);
      /*position: absolute;*/
      /*left: 0;*/
      /*top: 0;*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventCenter/EventCompare.vue